// bootstrap-spin - v1.0
// https://shaack.com/projekte/bootstrap-input-spinner/
!function(N){"use strict";function n(t,r){var o=t.locale||"en-US";this.parse=function(t){var e=new Intl.NumberFormat(o),n=e.format(11111).replace(/1/g,"")||".",e=e.format(1.1).replace(/1/g,"");return parseFloat(t.replace(new RegExp(" ","g"),"").replace(new RegExp("\\"+n,"g"),"").replace(new RegExp("\\"+e),"."))},this.render=function(t){var e=parseInt(r.getAttribute("data-decimals"))||0,n=!("false"===r.getAttribute("data-digit-grouping"));return new Intl.NumberFormat(o,{minimumFractionDigits:e,maximumFractionDigits:e,useGrouping:n}).format(t)}}var k=!1,r=N.fn.val;function F(t,e){t.addEventListener("mousedown",function(t){0===t.button&&(t.preventDefault(),e(t))}),t.addEventListener("touchstart",function(t){t.cancelable&&t.preventDefault(),e(t)}),t.addEventListener("keydown",function(t){32!==t.keyCode&&13!==t.keyCode||k||(k=!0,e(t))})}N.fn.val=function(t){var e;return 1<=arguments.length&&this[0]&&this[0]["bootstrap-input-spinner"]&&this[0].setValue&&(e=this[0],setTimeout(function(){e.setValue(t)})),r.apply(this,arguments)},N.fn.inputSpinner=function(t){if("destroy"===t)return this.each(function(){this.destroyInputSpinner()}),this;var e,C={decrementButton:"<strong>&minus;</strong>",incrementButton:"<strong>&plus;</strong>",groupClass:"",buttonsClass:"btn-outline-secondary",buttonsWidth:"2.5rem",textAlign:"center",autoDelay:500,autoInterval:50,buttonsOnly:!1,keyboardStepping:!0,locale:navigator.language,editor:n,template:'<div class="input-group ${groupClass}"><div class="input-group-prepend"><button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div><input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/><div class="input-group-append"><button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div></div>'};for(e in t)C[e]=t[e];var $=C.template.replace(/\${groupClass}/g,C.groupClass).replace(/\${buttonsWidth}/g,C.buttonsWidth).replace(/\${buttonsClass}/g,C.buttonsClass).replace(/\${decrementButton}/g,C.decrementButton).replace(/\${incrementButton}/g,C.incrementButton).replace(/\${textAlign}/g,C.textAlign);return this.each(function(){var r=N(this);r[0]["bootstrap-input-spinner"]=!0,r.hide(),r[0].inputSpinnerEditor=new C.editor(C,this);var e=null,n=null,o=N($),i=o.find(".btn-decrement"),a=o.find(".btn-increment"),p=o.find("input"),u=N("label[for='"+r.attr("id")+"']");u[0]||(u=r.closest("label"));var s=null,l=null,d=null;E();var c=parseFloat(r[0].value),t=r.attr("data-prefix")||"",f=r.attr("data-suffix")||"";t&&(t=N('<span class="input-group-text">'+t+"</span>"),o.find(".input-group-prepend").append(t)),f&&(m=N('<span class="input-group-text">'+f+"</span>"),o.find(".input-group-append").prepend(m)),r[0].setValue=function(t){b(t)},r[0].destroyInputSpinner=function(){r.prop("required",p.prop("required")),v.disconnect(),w(),p.off("paste input change focusout"),o.remove(),r.show(),u[0]&&u.attr("for",r.attr("id"))};var m,g,v=new MutationObserver(function(){E(),b(c,!0)});function b(t,e){void 0===e&&(e=!0),c=isNaN(t)||""===t?(r[0].value="",e&&(p[0].value=""),NaN):(t=parseFloat(t),t=Math.min(Math.max(t,s),l),r[0].value=t,e&&(p[0].value=r[0].inputSpinnerEditor.render(t)),t)}function h(e,n){n&&setTimeout(function(){var t;"function"==typeof Event?t=new Event(n,{bubbles:!0}):(t=document.createEvent("Event")).initEvent(n,!0,!0),e[0].dispatchEvent(t)})}function y(t){x(t),w(),e=setTimeout(function(){n=setInterval(function(){x(t)},C.autoInterval)},C.autoDelay)}function x(t){isNaN(c)&&(c=0),b(Math.round(c/t)*t+t),h(r,"input"),h(r,"change")}function w(){clearTimeout(e),clearTimeout(n)}function E(){r.prop("required")&&(p.prop("required",r.prop("required")),r.removeAttr("required")),p.prop("placeholder",r.prop("placeholder")),p.attr("inputmode",r.attr("inputmode")||"decimal");var t=r.prop("disabled"),e=r.prop("readonly");p.prop("disabled",t),p.prop("readonly",e||C.buttonsOnly),a.prop("disabled",t||e),i.prop("disabled",t||e),(t||e)&&w();t=r.prop("class"),e="";/form-control-sm/g.test(t)?e="input-group-sm":/form-control-lg/g.test(t)&&(e="input-group-lg");t=t.replace(/form-control(-(sm|lg))?/g,"");o.prop("class","input-group "+e+" "+C.groupClass),p.prop("class","form-control "+t),s=isNaN(r.prop("min"))||""===r.prop("min")?-1/0:parseFloat(r.prop("min")),l=isNaN(r.prop("max"))||""===r.prop("max")?1/0:parseFloat(r.prop("max")),d=parseFloat(r.prop("step"))||1,r.attr("hidden")?o.attr("hidden",r.attr("hidden")):o.removeAttr("hidden"),r.attr("id")&&(p.attr("id",r.attr("id")+"_MP_cBdLN29i2"),u[0]&&u.attr("for",p.attr("id")))}v.observe(r[0],{attributes:!0}),r.after(o),b(c),p.on("paste input change focusout",function(t){var e=p[0].value,n="focusout"===t.type;b(e=r[0].inputSpinnerEditor.parse(e),n),h(r,t.type)}).on("keydown",function(t){C.keyboardStepping&&(38===t.which?(t.preventDefault(),i.prop("disabled")||y(d)):40===t.which&&(t.preventDefault(),a.prop("disabled")||y(-d)))}).on("keyup",function(t){!C.keyboardStepping||38!==t.which&&40!==t.which||(t.preventDefault(),w())}),F(i[0],function(){i.prop("disabled")||y(-d)}),F(a[0],function(){a.prop("disabled")||y(d)}),m=document.body,g=function(){w()},m.addEventListener("mouseup",function(t){g(t)}),m.addEventListener("touchend",function(t){g(t)}),m.addEventListener("keyup",function(t){32!==t.keyCode&&13!==t.keyCode||(k=!1,g(t))})}),this}}(jQuery);

document.documentElement.classList.remove('no-js');

if ((typeof Theme) === 'undefined') { Theme = {}; }

Theme.isVisible = function(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  };

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
};
  
Theme.loadScript = function(script_to_load, callback){
  if(!loadedScripts.includes(script_to_load)){
    jQuery.getScript(script_to_load, function(){
      loadedScripts.push( script_to_load);
    }).done(function( script, textStatus ) {
      callback();
    });
  } else {
    callback();
  };
};


Theme.toggleAffix = function(affixElement, scrollElement, wrapper) {
  var height = affixElement.outerHeight(),
      top = wrapper.offset().top;

  if (scrollElement.scrollTop() >= top){
    wrapper.height(height);
    affixElement.addClass("affix");
  } else {
    affixElement.removeClass("affix");
    wrapper.height('auto');
  }
};

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

if( parseInt(jQuery(window).width()) < 992 ) { 
  var toastElList = [].slice.call(document.querySelectorAll('.toast'));
  var toastList = toastElList.map(function (toastEl) {
    return new bootstrap.Toast(toastEl, { delay:7000 });
  });
};

Theme.getTransitionEnd = function() {
  var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
   }
  let bodyStyle = document.body.style;
  for(let transition in transitions) {
      if(bodyStyle[transition] != undefined) {
          return transitions[transition];
      } 
  }
}

if (document.querySelectorAll(".fade-in").length > 0 ) {
  jQuery(document).on("scroll", function() {
    var pageTop = jQuery(document).scrollTop();
    var pageBottom = pageTop + jQuery(window).height();
    var tags = jQuery(".fade-in");

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];

      if (jQuery(tag).position().top < pageBottom) {
        jQuery(tag).addClass("is-visible");
      } else {
        jQuery(tag).removeClass("is-visible");
      }
    }
  });
};

if (document.querySelectorAll(".splash").length > 0 ) {
  jQuery(document).on("scroll", function() {
    var pageTop = jQuery(document).scrollTop();
    var pageBottom = pageTop + jQuery(window).height();
    var tags = jQuery(".splash");

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];

      if (jQuery(tag).position().top < pageBottom) {
        jQuery(tag).addClass("fade-out");
      } else {
        jQuery(tag).removeClass("fade-out");
      }
    }
  });
  
  document.querySelector(".splash").addEventListener('transitionend', function(ele){
    ele.target.style.display = "none";
  });
};

if (document.querySelectorAll(".product-buy").length > 0 ) {

  jQuery('.variant-select :radio').on('change', function () {
    
    jQuery(this).closest(".card-body").find(".card-title").html( jQuery(this).data("title") );
    jQuery(this).closest(".card-body").find(".product-price").html( jQuery(this).data("price") );
    
    var image_src = jQuery(this).data("image");
    jQuery(this).closest(".product-buy").find(".card-img-top").attr("src", image_src);
    //console.dir( jQuery(this).closest(".product-buy").find(".card-img-top").attr("src") );
    
    if(jQuery(this).data("available")) {
      jQuery(this).closest(".card-body").find("button").html("Add to Cart");
      jQuery(this).closest(".card-body").find("button").removeAttr("disabled");
    } else {
      jQuery(this).closest(".card-body").find("button").html("Sold Out");
	    jQuery(this).closest(".card-body").find("button").attr("disabled","disabled");
    }
  });
};


/* Click Add-to-Cart on item */
jQuery('[add-to-cart]').on('click', function (evt) {
  // if variant ID passed, use that
  evt.preventDefault();

  var product_id = jQuery(this).data('product-id');
  var variant_id = jQuery(this).data('variant-id');
  var quantity_to_add = 1;
  var card = jQuery('#product-'+product_id);

  /* item is already in cart */
  if(jQuery(this).hasClass('active') ) {
    Shopify.removeItem( variant_id, function() {});
    /* item is NOT in cart */
  } else {
    Shopify.addItem( variant_id, quantity_to_add, function(item) {});
  };
});

jQuery(".carousel").each(function( index ) {
  var carousel = jQuery(this).find('.slides');
  var carousel_display = carousel.data('slider-display');
  if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
    carousel.not('.slick-initialized').slick({
      slidesToShow: carousel.data('slider-slides'),
      slidesToScroll: 1,
      arrows: carousel.data('slider-arrows'),
      dots: carousel.data('slider-dots'),
      infinite: true,
      responsive: [
        {
          breakpoint: 982,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  };
});

jQuery('body :not(script)').contents().filter(function() {
  return this.nodeType === 3;
}).replaceWith(function() {
  return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
});

$(window).scroll(function(){
  if( $(this).scrollTop() > 500 ) {
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
});

if( window.innerWidth > 1024 ) {
  jQuery('[data-toggle="affix"]').each(function() {
    var ele = jQuery(this),
        wrapper = jQuery('<div></div>');

    ele.before(wrapper);
    jQuery(window).on('scroll resize', function() {
      Theme.toggleAffix(ele, $(this), wrapper);
    });

    // init
    Theme.toggleAffix(ele, jQuery(window), wrapper);
  });
}

/* NAVIGATION UX */
function assignNavigationEvents() {
  if( window.innerWidth > 1200 ) { /* Desktop Navigation */
    jQuery(".navbar-nav.tier-1 > .dropdown").hover(
      function(){ 
        jQuery(".navbar-nav.tier-1 .dropdown").removeClass('open'); 
        jQuery(this).addClass('open'); 
        jQuery('div.mainNavOverlay').addClass('active'); 
      },
      function(){ 
        jQuery(this).removeClass('open'); 
        jQuery('div.mainNavOverlay').removeClass('active');
      }
    );
    
    jQuery(".dropdown-toggle").click( function() {
      window.location = jQuery(this).attr('href');
    });
  } else { /* Mobile Navigation */
    let mainNav = jQuery('.navbar-nav.tier-1');

    jQuery('.navbar-toggler').on('click', function(evt) {
      mainNav.removeClass('open');
      mainNav.find('.dropdown.open').removeClass('open');
    });

    jQuery('.navbar-nav.tier-1 > .dropdown > .dropdown-toggle').on('click', function(evt) {
      evt.preventDefault();
      mainNav.toggleClass('open');
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('#navbar-tier-2 > .dropdown').on('click', function () {
      jQuery(this).siblings().removeClass('open');
      jQuery(this).toggleClass('open');
    });

    jQuery('a.menu-back').on('click', function () { 
      mainNav.removeClass('open');
      mainNav.find('.dropdown.open').removeClass('open');
      jQuery(this).parent().parent().focusout();
    });
  };
}
/* END NAVIGATION UX */


function saleCountdown(countdownElementId, timerElementId, dataAttribute) {
  var countdownElement = document.getElementById(countdownElementId);
  var timerElement = document.getElementById(timerElementId);

  if (countdownElement) {
    var saleEndDate = parseInt(document.querySelector(`[${dataAttribute}]`).getAttribute(dataAttribute));

    if (saleEndDate > new Date().getTime()) {
      countdownElement.style.display = 'flex';

      function updateCountdown() {
        var now = new Date().getTime();
        var timeDifference = saleEndDate - now;

        if (timeDifference <= 0) {
          timerElement.textContent = 'Sale ended!';
          clearInterval(intervalId);
          return;
        }

        var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        if (days > 0) {
          timerElement.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
        } else {
          timerElement.textContent = hours + 'h ' + minutes + 'm ' + seconds + 's';
        }
      }

      var intervalId = setInterval(updateCountdown, 1000);
      updateCountdown(); // Initial call to set timer immediately
    } else {
      // If the sale end date has already passed, show the message immediately
      timerElement.textContent = 'Sale ended!';
      countdownElement.style.display = 'flex'; // Ensure it stays visible
    }
  }
}

// Function to apply badges to the product card
function applyBadges(card, productData) {
  if (!productData.tags || !Array.isArray(productData.tags) || productData.tags.length === 0) return; // No tags, exit

  // console.log("Product Tags:", productData.tags); // Debugging

  // Check if the product is available; if not, return early to avoid duplicate "Sold Out" badges
  if (!productData.available) return;

  const innerContainer = card.querySelector(".spf-product-card__inner");
  if (!innerContainer) return;

  let badgeContainer = innerContainer.querySelector(".badge-container");

  // If badge container doesn't exist, create and prepend it
  if (!badgeContainer) {
      badgeContainer = document.createElement("div");
      badgeContainer.classList.add("badge-container");
      innerContainer.prepend(badgeContainer);
      // console.log("Badge container added");
  }

  badgeContainer.innerHTML = ""; // Clear existing badges

  const badgeLabels = {
      "online-exclusive": "Online Exclusive",
      "limited-edition": "Limited Edition",
      "sale": "Sale",
      "new": "New",
      "bundle-deal": "Bundle Deal",
      "free-gift": "Free Gift",
      "free-with-purchase" : "Free with purchase",
      "free-ground-sheet": "Free ground sheet",
      "new-prints": "New Prints",
      "new-colours": "New Colours",
      "back-in-stock" : "Back In Stock",
      "bestseller" : "Bestseller",
      "new-size" : "New Size",
      "updated" : "Updated",
      "gift-with-purchase" : "Gift With Purchase"
  };

  productData.tags.forEach(tag => {
      // console.log("Processing Tag:", tag); // Debugging

      if (badgeLabels[tag]) {
          const badge = document.createElement("div");
          badge.className = "product-badge";

          if (tag === "free-gift" || tag === "free-with-purchase" || tag === "free-ground-sheet" || tag === "sale") {
            badge.classList.add("badge-sale");
          }

          badge.textContent = badgeLabels[tag];
          badgeContainer.appendChild(badge);
      } else if (tag.toLowerCase().startsWith("save ")) { // Check for "save " with space
          const tagParts = tag.split(" "); // Split by space
          if (tagParts.length === 2) {
              // console.log("Save Badge Detected:", tagParts); // Debugging

              const badge = document.createElement("div");
              badge.className = "product-badge badge-sale";
              badge.textContent = `${tagParts[0].charAt(0).toUpperCase() + tagParts[0].slice(1)} ${tagParts[1]}`;
              badgeContainer.appendChild(badge);
          }
      } else if (tag.toLowerCase().startsWith("free ")) { // Check for "free " with space
          const tagParts = tag.split(" "); // Split by space
          if (tagParts.length === 2) {
              // console.log("Save Badge Detected:", tagParts); // Debugging

              const badge = document.createElement("div");
              badge.className = "product-badge";
              badge.textContent = `${tagParts[0].charAt(0).toUpperCase() + tagParts[0].slice(1)} ${tagParts[1]}`;
              badgeContainer.appendChild(badge);
          }
      }
  });
}


// Function to fetch product data and apply badges
function processProductCard(card) {
  const linkElement = card.querySelector("a.spf-product-card__image-wrapper");
  if (!linkElement) return;

  let productUrl = linkElement.getAttribute("href");
  if (!productUrl || productUrl.startsWith("javascript")) return;

  productUrl = productUrl.split("?")[0]; // Remove variant query string

  fetch(`${productUrl}.js`)
      .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
      })
      .then(productData => applyBadges(card, productData))
      .catch(error => console.error("Error fetching product data:", error));
}

// Function to observe changes inside .products
function observeProductChanges() {
  const productsContainer = document.querySelector(".products");
  if (!productsContainer) return;

  // Process initial product cards
  document.querySelectorAll(".spf-product-card").forEach(processProductCard);

  // MutationObserver to detect new products
  const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && node.classList.contains("spf-product-card")) {
                  processProductCard(node);
              } else if (node.nodeType === 1) {
                  // If a new section of products is added, check its children
                  node.querySelectorAll(".spf-product-card").forEach(processProductCard);
              }
          });
      });
  });

  observer.observe(productsContainer, { childList: true, subtree: true });
}


function initTopAnnouncementBannerSlickCarousel() {
  $('.announcement-banner .slick-wrapper')?.slick({
    infinite: true,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    adaptiveHeight: true,
    fade: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    useTransform: true,
    easing: 'ease',
    cssEase: 'ease'
  });
}

// Function to hide section anchor links on PDP if the target section does not exist
function hidePDPSectionAnchorLinks() {
  const anchorLinks = document.querySelectorAll('body.template-product  .anchor-links .nav-item > a.nav-link');
  
  anchorLinks.forEach(link => {
    const href = link.getAttribute('href');
    
    // Check if it's an anchor link
    if (href && href.startsWith('#')) {
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (!targetElement) {
        link.style.display = 'none';
      }
    }
  });
}

// initAutoplayVideoControl() pause autoplay videos when out of viewport, play when in viewport
function initAutoplayVideoControl() {
  const autoplayVideos = document.querySelectorAll('video[autoplay]');
  if (autoplayVideos.length === 0) return;

  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      
      if (entry.isIntersecting) {
        // Video is in viewport - play it
        if (video.paused) {
          video.play().catch(error => {
            // console.log('Video play failed:', error);
          });
        }
      } else {
        // Video is out of viewport - pause it
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    threshold: 0.2, // trigger when 20% of the video is visible
    rootMargin: '40px' // add some margin to trigger slightly before/after entering viewport
  });

  // Observe all autoplay videos
  autoplayVideos.forEach(video => {
    videoObserver.observe(video);
    
    // Initially pause videos that are not in viewport
    if (!Theme.isVisible(video)) {
      video.pause();
    }
  });
}

// fire events when the DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  assignNavigationEvents();
  initTopAnnouncementBannerSlickCarousel();
  observeProductChanges();
  saleCountdown('countdown-timer-header', 'timer-header', 'data-sale-end-date-header'); // Header
  saleCountdown('countdown-timer', 'timer', 'data-sale-end-date'); // PDP
  hidePDPSectionAnchorLinks();
  initAutoplayVideoControl();
});